import React from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";

const StoreShippingSettings = () => {
  return (
    <>
      <div className="hstack justify-content-between mb-2 pt-3 px-3 pb-1">
        <Form.Group>
          <h6 className="m-0 d-block">Shipping Settings</h6>
          <Form.Text style={{ fontSize: 12 }}>
            Configure how orders are shipped, rated, and fulfilled.
          </Form.Text>
        </Form.Group>
        <Button size="sm">Save</Button>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 175px)" }}>
        <div className="px-3 pb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <Form.Group className="mb-2">
                <Row className="g-2">
                  <Col xs={12}>
                    <Form.Label className="m-0">Shipping Origin</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="City, State, Country"
                      required
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Default Carrier</Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>UPS</option>
                      <option>FedEx</option>
                      <option>USPS</option>
                      <option>DHL</option>
                      <option>Other</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Shipping Zones</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Domestic, International (optional)"
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Processing Time</Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>1-2 business days</option>
                      <option>3-5 business days</option>
                      <option>5-7 business days</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">
                      Shipping Calculations
                    </Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>Per Order</option>
                      <option>Per Item</option>
                      <option>By Weight</option>
                      <option>By Carrier Rates</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Shipping Method</Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>Flat Rate</option>
                      <option>Free Shipping</option>
                      <option>Calculated by Carrier</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">
                      Shipping Destination
                    </Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>Domestic Only</option>
                      <option>International Only</option>
                      <option>Domestic and International</option>
                      <option>Specific Countries</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Flat Rate Amount</Form.Label>
                    <InputGroup>
                      <InputGroup.Text style={{ fontSize: 13 }}>
                        <span>$</span>
                      </InputGroup.Text>
                      <Form.Control type="number" min={0} placeholder="0.00" />
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">
                      Free Shipping Threshold
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text style={{ fontSize: 13 }}>
                        <span>$</span>
                      </InputGroup.Text>
                      <Form.Control type="number" min={0} placeholder="0.00" />
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Handling Fee</Form.Label>
                    <InputGroup>
                      <InputGroup.Text style={{ fontSize: 13 }}>
                        <span>$</span>
                      </InputGroup.Text>
                      <Form.Control type="number" min={0} placeholder="0.00" />
                    </InputGroup>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Weight Unit</Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>lb</option>
                      <option>kg</option>
                      <option>oz</option>
                      <option>g</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Dimension Unit</Form.Label>
                    <Form.Select style={{ fontSize: 13 }} required>
                      <option>in</option>
                      <option>cm</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6} className="d-flex align-items-end">
                    <Form.Check
                      type="switch"
                      id="shipping-debug-mode"
                      label="Debug Mode"
                    />
                  </Col>
                  <Col xs={12}>
                    <Form.Label className="m-0">Shipping Notes</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Optional message shown to customers"
                    />
                  </Col>
                </Row>
              </Form.Group>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default StoreShippingSettings;
